import { compose, nest, withProps } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import { Success } from "components/common/referral";
import { Overlay } from "components/common/insider";

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withProps({
    text: "Your friends will receive 20$ discount on their first call."
  })
)(nest(Overlay, Success));



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ReferralSuccess/index.js